import { forwardRef } from 'react';

import { ChevronRight } from '../Icons';
import * as Styled from './Carousel.styles';

const CarouselNext = forwardRef(({ className, disabled, ...props }, ref) => {
  return (
    <Styled.NavButton
      ref={ref}
      type="button"
      className={className}
      disabled={disabled}
      {...props}
    >
      <ChevronRight />
    </Styled.NavButton>
  );
});

CarouselNext.displayName = 'CarouselNext';

export default CarouselNext;
